import { browser } from '$app/environment';
import { Page } from '$lib/utils/page';
import { pageConditions } from './__config/conditions';
import { policy, policyExceptionHandler } from './-policy';

export const prerender = true;

/**
 * Loads the page data
 * @returns {Promise<{page: Page} | undefined>} - The page data
 */
export async function load() {
	if (browser) {
		const page = new Page({
			routePath: '/prospect-register',
			policies: { policy, policyExceptionHandler },
			conditions: pageConditions,
		});
		return {
			page,
		};
	}
}
